var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPythonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc851",
    d: "m22 10v3c0 1.662-1.338 3-3 3h-6s-3 0-3 3v5.25c0 2.078 2.342 3.75 5.25 3.75h1.5c2.908 0 5.25-1.672 5.25-3.75v-2.25h2.25c2.078 0 3.75-2.342 3.75-5.25v-1.5c0-2.908-1.672-5.25-3.75-5.25h-2.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m19 25a1 1 0 0 1 1 1 1 1 0 0 1 -1 1 1 1 0 0 1 -1 -1 1 1 0 0 1 1 -1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19 24a1 1 0 0 1 1 1 1 1 0 0 1 -1 1 1 1 0 0 1 -1 -1 1 1 0 0 1 1 -1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4795d1",
    d: "m15.25 4c-2.908 0-5.25 1.6725-5.25 3.75v2.25h-2.25c-2.0775 0-3.75 2.342-3.75 5.25v1.5c0 2.908 1.6725 5.25 3.75 5.25h2.25v-3c0-1.662 1.338-3 3-3h6s3 0 3-3v-5.25c0-2.0775-2.342-3.75-5.25-3.75h-1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m13 7a1 1 0 0 1 1 1 1 1 0 0 1 -1 1 1 1 0 0 1 -1 -1 1 1 0 0 1 1 -1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 6a1 1 0 0 1 1 1 1 1 0 0 1 -1 1 1 1 0 0 1 -1 -1 1 1 0 0 1 1 -1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "m15.25 4c-2.908 0-5.25 1.6725-5.25 3.75v1c0-2.0775 2.342-3.75 5.25-3.75h1.5c2.908 0 5.25 1.6725 5.25 3.75v-1c0-2.0775-2.342-3.75-5.25-3.75zm-7.5 6c-2.0775 0-3.75 2.342-3.75 5.25v1c0-2.908 1.6725-5.25 3.75-5.25h2.25v-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "m22 10v1h2.25c2.0775 0 3.75 2.3415 3.75 5.25v-1c0-2.908-1.672-5.25-3.75-5.25zm0 3c0 1.662-1.338 3-3 3h-6s-3 0-3 3v1c0-3 3-3 3-3h6c1.662 0 3-1.338 3-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m22 13c0 3-3 3-3 3h-6c-1.662 0-3 1.338-3 3v1c0-1.662 1.338-3 3-3h6s3 0 3-3zm-18 3.75v1c0 2.908 1.6725 5.25 3.75 5.25h2.25v-1h-2.25c-2.0775 0-3.75-2.342-3.75-5.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m28 16.75c0 2.908-1.672 5.25-3.75 5.25h-2.25v1h2.25c2.078 0 3.75-2.342 3.75-5.25zm-18 7.5v1c0 2.0775 2.3415 3.75 5.25 3.75h1.5c2.908 0 5.25-1.672 5.25-3.75v-1c0 2.078-2.342 3.75-5.25 3.75h-1.5c-2.908 0-5.25-1.672-5.25-3.75z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python_icon.18415efe2f73636f3fe7b51face8d2e4.svg";
export { ForwardRef as ReactComponent };